import React from 'react';

import { Box, Container, Text,VStack } from '@bpba/ui-components';

import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import { Info } from '../components/Info';
import { ComponentePrestamoPersonalSP } from '../components/ComponentePrestamoPersonalSP';
import { PRESTAMOPERSONAL_BANNER } from '../Constantes';
import { infoPrestamoPersonalList } from '../components/Listas';

export const PrestamosPersonalSP: React.FC = () => {

  

return (
<>
   <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={PRESTAMOPERSONAL_BANNER} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Préstamo Personal'} ></Title>
                                <Info infoList={infoPrestamoPersonalList} info={''}></Info>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ComponentePrestamoPersonalSP />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>

                        El click en SI acepto, implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptación. Asimismo, tomo conocimiento de los términos y condiciones para la utilización de Banca Internet Provincia y de la información necesaria para su correcta utilización, los riesgos derivados de su empleo y quien asume los mismos. El click en Imprimir permite obtener una copia que también se encuentra a disposición en www.bancoprovincia.com.ar
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>
   
    
  </>
  );
}